import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { API_URL } from '../consts';
import { PortfolioData } from '../types';

const useFetchInitialData = (portfolioId: string) => {
  const [data, setData] = useState<PortfolioData | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const url = `${API_URL}/api/portfolios/${portfolioId}/families/?format=json`;
      const response = await axios.get(url);
      setData(response.data);
    } catch (err) {
      setError((err as any).toJSON());
    } finally {
      setLoading(false);
    }
  }, [portfolioId]);

  useEffect(() => {
    if (portfolioId) {
      fetchData();
    }
  }, [portfolioId, fetchData]);

  return { data, loading, error, refetch: fetchData, setData };
};

export default useFetchInitialData;
